import { render, staticRenderFns } from "./PositionDivisibleVolumeInfoFix.vue?vue&type=template&id=3710b235&"
import script from "./PositionDivisibleVolumeInfoFix.vue?vue&type=script&lang=js&"
export * from "./PositionDivisibleVolumeInfoFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports